import { mapKeysToCamelCase } from '@skytech/utils'

import { get, post } from '@/util/auth'

import { API_ROUTE_DATA_SEEDING, API_ROUTE_DATA_SEEDING_DEMO_TARGETS } from './apiRoutes'

const IS_NEW_BACKEND_API = true

export type DemoCustomersListTypeOriginal = DemoCustomersTypeOriginal[]
export type DemoCustomersTypeOriginal = {
  id: number
  name: string
  customer_head_id: number
  customer_head_name: string
  users: UserOriginal[]
  costObjects: CostObjectOriginal[]
}
export type UserOriginal = {
  id: number
  first_name: string
  last_name: string
  phone_number: string
  country_id: number
  customer_id: number
  role: string
  access_code: string
}
export type CostObjectOriginal = {
  id: number
  name: string
  phone_number: string
  country_id: number
  customer_id: number
  department_id: number
  department_code: string
  department_name: string
  access_code: string
}

export type User = {
  id: number
  firstName: string
  lastName: string
  phoneNumber: string
  countryId: number
  customerId: number
  role: string
  accessCode: string
}
export type CostObject = {
  id: number
  name: string
  phoneNumber: string
  countryId: number
  customerId: number
  departmentId: number
  departmentCode: string
  departmentName: string
  accessCode: string
}

type DemoTargetsOriginal = {
  managerUrl: string
  appUrl: string
}

export const demoCustomersResources = {
  getDemoTargets: async () => {
    const responseOriginal = await get<DemoTargetsOriginal>(
      API_ROUTE_DATA_SEEDING_DEMO_TARGETS,
      IS_NEW_BACKEND_API
    )
    const response = mapKeysToCamelCase(responseOriginal)
    return response
  },
  getList: async () => {
    const responseOriginal = await get<DemoCustomersListTypeOriginal>(
      API_ROUTE_DATA_SEEDING,
      IS_NEW_BACKEND_API
    )
    const response = mapKeysToCamelCase(responseOriginal)
    return response
  },
  // Mutations
  postDemoCustomer: async (payload: {
    customerName: string
    customerCount: number
    customerNames: string[]
    countryId: number
    whitelabelId: number
    numberOfDepartmentsPerCustomer: number
    numberOfCostObjectsPerDepartment: number
    startDate: string | null
    expiryDate: string | null
  }) => await post(API_ROUTE_DATA_SEEDING, payload, IS_NEW_BACKEND_API),
}

export type DemoTargets = Awaited<ReturnType<typeof demoCustomersResources.getDemoTargets>>
export type DemoCustomers = Awaited<ReturnType<typeof demoCustomersResources.getList>>[number]
export type AddDemoCustomerPayload = Parameters<
  typeof demoCustomersResources.postDemoCustomer
>[number]
